import { fromTheme } from '@twind/core';
// indirection wrapper to remove autocomplete functions from production bundles
function presetLineClamp() {
    return {
        rules: [
            [
                'line-clamp-none',
                {
                    '-webkit-line-clamp': 'unset'
                }
            ],
            [
                'line-clamp-',
                fromTheme('lineClamp', ({ _  })=>lineClamp(_))
            ],
            [
                'line-clamp-(\\d+)',
                ({ 1: _  })=>lineClamp(_)
            ]
        ]
    };
}
function lineClamp(lines) {
    return {
        overflow: 'hidden',
        display: '-webkit-box',
        '-webkit-box-orient': 'vertical',
        '-webkit-line-clamp': `${lines}`
    };
}
export { presetLineClamp as default };
//# sourceMappingURL=preset-line-clamp.js.map
